/* eslint-disable max-lines */
export default {
  new_feature_notification: {
    check_out_new_feature: 'Sprawdź nową funkcję!'
  },
  change_request_modal: {
    title: 'Wniosek o zmianę został złożony',
    message:
      'Twój wniosek o edycję został pomyślnie złożony. Proszę czekać na zatwierdzenie przez administratora przed kontynuowaniem.',
    got_it: 'Rozumiem'
  },
  blocked_app_modal: {
    title: 'Konto zablokowane',
    message: 'Twoje konto zostało zablokowane. Aby uzyskać więcej informacji, skontaktuj się z administratorem.',
    contact_admin: 'Skontaktuj się z administratorem',
    additional_info:
      'Jeśli uważasz, że to błąd lub potrzebujesz natychmiastowej pomocy, skontaktuj się z naszym zespołem wsparcia. Przepraszamy za wszelkie niedogodności.'
  },
  captcha_page: {
    title: 'Potwierdź, że nie jesteś robotem, aby kontynuować.',
    error: 'Weryfikacja nie powiodła się. Spróbuj ponownie.',
    expired: 'Weryfikacja wygasła. Spróbuj ponownie.',
    load_error: 'Nie udało się załadować weryfikacji. Odśwież stronę.',
    verifying: 'Weryfikowanie...'
  },
  phone_confirmation_modal: {
    title: 'Potwierdź numer telefonu',
    description: 'Podaj numer telefonu. Wyślemy na niego SMS.',
    phone: 'Numer telefonu',
    phone_placeholder: '+48 111 222 333',
    send_sms: 'Wyślij SMS',
    sending: 'Wysyłanie...',
    sent: 'SMS został wysłany.',
    too_soon: 'Poczekaj minutę przed wysłaniem kolejnego SMS-a.',
    limit_reached: 'Możesz wysłać najwyżej 5 SMS-ów na godzinę. Spróbuj później.',
    phone_required: 'Numer telefonu jest wymagany',
    error: 'Nie udało się wysłać SMS. Spróbuj ponownie.',
    code: 'Kod z SMS',
    code_placeholder: '123456',
    confirm: 'Potwierdź',
    confirming: 'Potwierdzanie...',
    invalid_code: 'Kod jest nieprawidłowy.',
    code_required: 'Wpisz kod z SMS-a.',
    confirm_error: 'Nie udało się potwierdzić numeru. Spróbuj ponownie.'
  },
  demo_modal: {
    demo_expired: 'Demo wygasło',
    title: 'Masz Pytania?',
    title_highlight: 'Chętnie Pomożemy!',
    subtitle:
      'Jeśli masz jakiekolwiek pytania dotyczące tego kroku lub samej platformy, napisz do nas na adres partner@estigroup.de. Nasz zespół szybko odpowie i pomoże Ci rozpocząć pracę.',
    badge: 'Pełny dostęp dealera',
    full_access_title: 'Pełny dostęp',
    full_access_description: 'Dla dealerów gotowych do rozpoczęcia pozyskiwania motocykli i osiągania zysków.',
    price: '990€',
    price_period: '/ jednorazowa płatność',
    features: {
      live_listings: 'Pełny dostęp do aktualnych, zweryfikowanych ofert od prywatnych sprzedawców',
      bid_buy: 'Pełna możliwość licytacji lub zakupu, z pełną kontrolą nad transportem',
      priority_support: 'Priorytetowa obsługa i wsparcie dla dealerów',
      mobile_app: 'Pełny dostęp do aplikacji mobilnej'
    },
    support_text:
      'Jeśli masz pytania dotyczące tego kroku lub samej platformy, napisz do nas na partner@estigroup.de — nasz zespół szybko odpowie, aby pomóc Ci rozpocząć.',
    form: {
      title: 'Uzupełnij Dane Firmowe, Aby Odblokować Pełny Dostęp.',
      description:
        'Potrzebujemy tych informacji, aby przygotować Twoją umowę dealerską i aktywować pełną możliwość zakupupojazdów na platformie.',
      company_id: 'ID firmy',
      company_id_placeholder: 'Twoje ID',
      company_name: 'Nazwa firmy',
      company_name_placeholder: 'Nazwa firmy',
      address: 'Adres',
      address_placeholder: 'Nazwa ulicy',
      city: 'Miasto',
      city_placeholder: 'Nazwa miasta',
      postal_code: 'Kod pocztowy',
      postal_code_placeholder: 'Kod pocztowy',
      phone_number: 'Numer telefonu',
      phone_number_placeholder: 'Twój numer telefonu',
      privacy_policy: 'Przesyłając moje dane potwierdzam, że przeczytałem i zrozumiałem Politykę Prywatności Estimoto',
      submit_button: 'Poproś o pełny dostęp',
      errors: {
        company_id_required: 'ID firmy jest wymagane',
        company_name_required: 'Nazwa firmy jest wymagana',
        address_required: 'Adres jest wymagany',
        city_required: 'Miasto jest wymagane',
        postal_code_required: 'Kod pocztowy jest wymagany',
        phone_number_required: 'Numer telefonu jest wymagany',
        privacy_policy_required: 'Musisz zaakceptować politykę prywatności'
      }
    }
  },
  test_access_banner: {
    demo_mode: 'Tryb demo',
    expires_on: 'Wygasa',
    contact_support: 'Skontaktuj się z pomocą',
    upgrade_now: 'Ulepsz teraz'
  },
  pagination: {
    showing_items: '{{startItem}}-{{endItem}} z {{totalItems}} wyników'
  },
  only_buy_now_dec: 'ZOBACZ TYLKO OFERTY',
  only_buy_now: 'Kup teraz',
  just_sold: 'Właśnie sprzedane',
  in_realization_list_item: {
    contact_info: 'Kontakt do sprzedającego',
    email: 'E-mail',
    phone: 'Telefon',
    help: 'Pomoc',
    arrange_transport: 'Umów transport',
    transport_arranged: 'Przekazano do spedycji',
    transport_arranged_long: 'Pojazd został przekazany do spedycji, spedytor skontaktuje się z Tobą',
    confirm_receipt: 'Potwierdzam odbiór',
    vehicle_data: 'Szczegóły pojazdu',
    contract_pdf: 'Umowa sprzedaży',
    spedition: 'Przekazuje do spedycji',
    choose_spedition: 'Wybierz spedytora',
    spedition_note: 'Dodaj wiadomość do spedytora',
    spedition_terms_1: 'Przekazując do spedycji akceptujesz regulamin i warunki wybranej firmy spedycyjnej.',
    create_transport_button: 'Przekaż do spedycji',
    confirm_pick_up: 'Pojazd został pomyślnie zakupiony oraz odebrany',
    confirm_button: 'Potwierdzam odbiór',
    cancel: 'Anuluj',
    accepted: 'Zaakceptowana',
    credit_data: 'Dane kredytu',
    price: 'Cena dla klienta',
    provision: 'Prowizja',
    deregistering_person: 'Wyrejestrowanie pojazdu',
    deregistering_person_dealer: 'Kupujący (dealer)',
    deregistering_person_seller: 'Sprzedawca',
    deregistering_person_later: 'Do ustalenia',
    deregistering_person_already_deregistered: 'Pojazd został wyrejestrowany'
  },
  invoices_screen: {
    screen_title: 'Faktury'
  },
  bottom_menu: {
    sell: 'Sprzedaje',
    search: 'Szukaj',
    want_to_buy: 'Skupuje',
    settings: 'Ustawienia'
  },
  platform_terms: {
    title: 'Regulaminy',
    files: [
      { label: 'Dodatkowe Ogólne Warunki Handlowe (OWH-Z)', href: '/Dodatkowe Ogólne Warunki Handlowe (OWH-Z).pdf' },
      { label: 'Ogólne Warunki Handlowe (OWH)', href: '/Ogólne Warunki Handlowe (OWH).pdf' }
    ]
  },
  soon: 'Wkrótce',
  buy_now_modal: {
    title: 'Kupujesz za kwotę zaakceptowaną przez sprzedającego',
    by_clicking: 'Klikając',
    buy_now: 'Kup teraz',
    you_realize_sell: 'realizujesz zakup i akceptujesz aktualny',
    terms: 'regulamin',
    buy_now_button: 'Kup teraz',
    realization: 'Przejdź do realizowanych',
    you_offer_has_been_sent: 'Twoja oferta kup teraz została \n wysłana do sprzedawcy.',
    go_to_realization: 'Przejdź do zakładki realizowane, \n żeby śledzić dalsze kroki.'
  },
  auction_contract_modal: {
    title: 'Zaproponuj realną cenę.',
    terms:
      'Zaproponuj realną cenę. Twoja oferta jest przez 14 dni wiążąca. Składając ofertę akceptujesz nasz regulamin.',
    resign: 'Rezygnuję',
    place_offer: 'Składam ofertę',
    place_offer_title: 'Składam ofertę',
    go_to_bets: 'Przejdź do skupowanych',
    go_to_bets_desc: 'Przejdź do zakładki skupowanych, \n żeby śledzić dalsze kroki.',
    your_offer_has_been_sent: 'Twoja oferta została \n wysłana do admina \n i czeka na zatwierdzenie.',
    only_fail_offer_will_be_sent:
      'Pamiętaj, jeśli oferta będzie \n za niska, admin nie ma obowiązku \n przedstawienia jej sprzedającemu.',
    we_will_notify: '',
    by_clicking: 'Klikając',
    you_are_accepting: 'akceptujesz aktualny',
    term: 'klikając <strong>Składam ofertę</strong> akceptujesz aktualny <strong>regulamin</strong>.'
  },
  single_offer: {
    check_price_on_mobile: 'Sprawdź cenę',
    roadworthy: 'Odpala, jeździ',
    not_roadworthy: 'Nie odpala, nie jeździ',
    gross_vehicle_weight: 'Dopuszczalna masa całkowita',
    date_of_first_registration: 'Data pierwszej rejestracji',
    length: 'Długość',
    width: 'Szerokość',
    engine_capacity: 'Pojemność',
    engine_power: 'Moc',
    automatic_gearbox: 'Automatyczna skrzynia',
    year_of_production: 'Data produkcji',
    added: 'Dodany',
    ago: 'temu',
    unread_messages: 'Wiadomości',
    screen_title: 'Szczegóły pojazdu',
    gallery: 'Galeria',
    your_highest: 'Twoja oferta',
    buy_now: 'Kup Teraz',
    minimal_price: 'Cena minimalna',
    place_an_offer: 'Złóż ofertę',
    place_an_different_offer: 'Złóż inną ofertę',
    buy_now_button: 'Kup teraz',
    vehicle_description: 'Szczegóły pojazdu',
    first_registration: 'Data pierwszej rejestracji',
    total_mileage: 'Przebieg',
    zip_code: 'Kod Pocztowy',
    origin_country: 'Kraj pochodzenia',
    import_description_options: {
      germany: 'Niemcy',
      austria: 'Austria',
      italy: 'Włochy',
      netherlands: 'Holandia',
      usa: 'Stany Zjednoczone',
      great_britain: 'Wielka Brytania',
      france: 'Francja',
      belgium: 'Belgia',
      not_known: 'Nieznany',
      other: 'Nieznany'
    },
    rental_description: 'Przeznaczenie komercyjne',
    rental_description_options: {
      demo: 'pojazd demonstracyjny',
      driving_course: 'nauka jazdy',
      rental: 'wypożyczalnia'
    },
    used_commercially: 'Używany komercyjnie',
    not_rental: 'Nie używany komercyjnie',
    previous_owners: 'Ilość Właścicieli',
    number_of_previous_owners_options: {
      _0_: '0',
      _1_: '1',
      _2_: '2',
      _3_: '3',
      _4_: '4',
      more_than_4: 'więcej niż 4',
      not_known: 'nieznana'
    },
    addiction_info: 'Informacje Dodatkowe',
    accident_free: 'Bezwypadkowy',
    with_accident: 'Wypadkowy',
    not_wrecked: 'Bezprzewrotki',
    wrecked: 'Przewrotka',
    original_lacquer: 'Oryginalny lakier',
    not_original_lacquer: 'Lakier nie oryginalny',
    without_defects: 'Brak uszkodzeń',
    defects: 'Uszkodzenia',
    with_trailer: 'Z przyczepą transportową',
    without_trailer: 'Bez przyczepy transportowej',
    accessories_description: 'Akcesoria',
    admin_comment: 'Komentarz',
    not_financed_vehicle: 'Brak obciążeń finansowych',
    financed_vehicle_1: 'Pojazd obciążony kredytem',
    abs: 'ABS',
    vin: 'VIN',
    without_abs: 'Bez ABS',
    not_imported: 'Krajowy',
    with_service_booklet: 'Książka Serwisowa',
    motorbike_service_booklet_options: {
      not_run: 'Nie prowadzona',
      existing: 'Istniejąca',
      run: 'Prowadzona',
      digitally_run: 'Elektronicznie prowadzona'
    },
    not_categorized_attributes_section_title: 'Szczegóły pojazdu',
    general_condition_section_title: 'STAN OGÓLNY POJAZDU',
    score: 'Ocena Scoringowa',
    general_condition: 'Stan Ogólny',
    consumables_condition: 'Części eksploatacyjne',
    tires: 'Opony',
    tires_age: 'Wiek opon',
    tires_condition: 'Profil bieżnika',
    motorbike_general_condition_options: {
      as_new: 'Jak nowy',
      well_maintained: 'Bardzo dobry',
      average: 'Dobry',
      bad: 'Zły',
      care: 'Dostateczny',
      tatty: 'Dopuszczający'
    },
    motorbike_consumables_condition_options: {
      as_new: 'Jak nowe',
      well_maintained: 'Dobre',
      average: 'Średnie',
      tatty: 'w złym stanie',
      not_known: 'Nieznane',
      bad: '',
      care: ''
    },
    motorbike_tires_options: {
      '25%': '25%',
      '50%': '50%',
      '75%': '75%',
      bad: 'Zużyte lub starsze niż 6 lat',
      very_well: 'Nowe',
      not_known: 'Nieznany'
    },
    motorbike_tires_age_options: {
      under_six_years_old: 'Poniżej 6 lat',
      over_six_years_old: '6 lat lub więcej',
      not_known: 'Nie znam się na tym'
    },
    motorbike_tires_condition_options: {
      _0_: 'Zużyte',
      _25_: '25%',
      _50_: '50%',
      _75_: '75%',
      _100_: 'Nowe',
      not_known: 'Nie znam się na tym'
    },
    services: 'Przeglądy',
    motorbike_last_inspection: 'Ostatni serwis',
    motorbike_next_hu: 'Następny przegląd',
    photos_screen_title: 'Galeria pojazdu',
    camper_number_of_seats: 'Ilość siedzeń',
    camper_commercial_use: 'Użytek komercyjny',
    camper_without_commercial_use: 'Nie używany komercyjnie',
    bool_options: {
      true: 'Tak',
      false: 'Nie'
    },
    camper_type: 'Typ kampera',
    camper_type_options: {
      caravan: 'Wohnwagen',
      van: 'Kastenwagen/CUV',
      semi_integrated: 'Teilintegrierter',
      fully_integrated: 'Vollintegrierter',
      alcove: 'Alkoven',
      luxury: 'Luxus-Liner',
      car: 'PKW'
    },
    camper_next_hu: 'Następny przegląd',
    camper_last_inspection: 'Ostatni przegląd',
    agricultural_production_year: 'Rok produkcji',
    agricultural_meter: 'licznik',
    agricultural_general_condition_options: {
      as_new: 'Jak nowy',
      well_maintained: 'Bardzo dobry',
      average: 'Dobry',
      bad: 'Zły',
      care: 'Dostateczny',
      tatty: 'Dopuszczający'
    }
  },
  browse: 'Pojazdy',
  all_vehicles: 'Wszystkie pojazdy',
  liked_vehicles: 'Polubione',
  first_offer: 'Brak ofert',
  highest_offer: 'Najwyższa oferta',
  highest_offer_short: 'Najwyższa oferta',
  first_offer_short: 'Brak ofert',
  buy_now: 'Kup teraz',
  no_offers: 'Nie ma ofert spełniających podane kryteria',
  offer_to_low: 'Kwota musi wynosić co najmniej € ',
  date: 'Data rejestracji',
  agricultural_production_year: 'Rok',
  mileage: 'Przebieg',
  country: 'Kraj',
  bets_count: 'Ilość złożonych ofert',
  your_offer: 'Twoja oferta',
  buy_now_expanded_view: 'Kup Teraz',
  minimal_offering: 'Cena Minimalna',
  new_offer_button: 'Przebij ofertę',
  buy_now_button: 'Kup teraz',
  bets_table_title: 'Moje skupowane',
  archive_tab_title: 'Archiwum skupowane',
  sold_tab_title: 'Archiwalne',
  in_realization_table: 'W realizacji',
  messages: 'Wiadomości',
  auctions: 'Moje Licytacje',
  in_realization: 'W Realizacji',
  invoices: 'Faktury',
  archive: 'Archiwum',
  my_auctions: 'Moje Licytacje',
  accepted_offer: 'Oferta przyjęta',
  archived_date: 'Zarchiwizowano',
  sold: 'Sprzedane',
  app_should_be_updated: 'Aplikacja potrzebuje aktualizacji',
  update: 'Aktualizuj',
  Motorbike_offers: 'Motocykle',
  JetSki_offers: 'Skutery wodne',
  AgriculturalMachine_offers: 'Maszyny Rolnicze',
  Camper_offers: 'Kampery',
  message_placeholder: 'Wpisz tutaj swoją wiadomość',
  application_version: 'Wersja aplikacji',
  remove_account: 'Usuń konto',
  log_out: 'Wyloguj',
  profile: 'Profil',
  profile_settings: 'Ustawienia profilu',
  company_data: 'Dane firmy',
  auth_settings: 'USTAWIENIE HASŁA I LOGOWANIA',
  update_application: 'Aktualizacja',
  check_updates: 'Sprawdź dostępność aktualizacji',
  remove_account_confirmation: 'Czy na pewno chcesz usunąć konto?',
  set_password: 'Ustaw hasło',
  set_language: 'Ustaw język',
  integrations: 'Integracje',
  integrations_screen: {
    title: 'Integracje',
    login: 'Login',
    password: 'Hasło',
    add: 'Dodaj integrację',
    empty: 'Nie masz jeszcze podłączonej integracji.',
    cancel: 'Anuluj',
    connect: 'Połącz',
    connected: 'Konto podłączone',
    seller_id: 'ID sprzedawcy',
    sync: 'Synchronizuj pojazdy',
    sync_started: 'Synchronizacja wystartowała. Pojazdy pojawią się na liście pojazdów.',
    connect_success: 'Konto mobile.de zostało podłączone',
    connect_error: 'Nie udało się podłączyć konta',
    load_error: 'Nie udało się pobrać listy integracji',
    sync_error: 'Nie udało się uruchomić synchronizacji',
    disconnect: 'Usuń integrację',
    disconnect_title: 'Usunąć integrację?',
    disconnect_message:
      'Konto zostanie odłączone. Ogłoszenia zostaną na mobile.de. Potem możesz dodać integrację ponownie, na przykład z nowym hasłem.',
    disconnect_confirm: 'Usuń',
    disconnect_success: 'Integracja została usunięta',
    disconnect_error: 'Nie udało się usunąć integracji'
  },
  profile_settings_screen_header: 'Ustawienia profilu',
  save_password: 'Zapisz',
  update_password_form: {
    current_password: 'Obecne hasło',
    new_password: 'Nowe hasło',
    confirm_new_password: 'Potwierdź hasło',
    password_not_match: 'Podane hasła różnią się',
    password_do_not_meet_requirements: 'Hasło powinno zawierać dużą oraz małą literę, cyfrę oraz znak specjalny',
    current_password_invalid: 'Podane Hasło nieprawidłowe',
    password_to_short: 'Hasło jest zbyt krótkie',
    unknown_error: 'Coś poszło nie tak, sprobuj jeszcze raz'
  },
  sign_in_screen: {
    do_not_have_account: 'Nie masz jeszcze kąta',
    registration: 'Rejestracja',
    registration_url: 'https://estigroup.pl',
    title: 'Logowanie',
    forgot_password: 'Nie pamiętasz hasła?',
    forgot_password_description: 'Wpisz swój adres Email, na który wyślemy link do resetowania hasła',
    sign_in: 'Zaloguj',
    forgot_password_title: 'Przypomnij hasło',
    remind_password: 'Wyślij',
    reset_instructions_sent: 'Instrukcja resetowania hasła została wysłane na Twój adres e-mail',
    password_invalid: 'Hasło nieprawidłowe',
    email_invalid: 'E-mail nieprawidłowy',
    password: 'Hasło',
    new_password: 'Nowe hasło',
    repeat_password: 'Powtórz hasło',
    reset_password: 'Zresetuj hasło',
    password_requirement_uppercase: 'Min. 1 wielka litera',
    password_requirement_number: 'Min. 1 cyfra',
    password_requirement_special_char: 'Min. 1 znak specjalny (!#$%@*^&)',
    password_requirement_min_length: 'Min. 8 znaków'
  },
  profile_settings_form: {
    name: 'Imię',
    last_name: 'Nazwisko',
    nickname: 'Nazwa wyświetlana',
    phone: 'Telefon',
    email: 'E-mail',
    company_name: 'Nazwa firmy',
    ftin: 'NIP',
    street: 'Ulica',
    zip_code: 'Kod pocztowy',
    place: 'Miasto',
    iban: 'IBAN',
    bic: 'BIC',
    save: 'Zapisz'
  },
  filter_modal: {
    localization: 'Lokalizacja',
    vehicle: 'Pojazd',
    hash_id: 'Numer ID',
    damaged_label: 'Stan pojazdu',
    damaged: 'Uszkodzony',
    not_damaged: 'Nie uszkodzony',
    all: 'Wszystkie',
    year_form: 'Rok od',
    year_to: 'Rok do',
    milage_from: 'Przebieg od',
    milage_to: 'Przebieg do',
    zpi_code_input: 'Kod pocztowy',
    area: 'Obszar',
    country: 'Kraj',
    filter_offers: 'Filtrowanie Ofert',
    filter_button: 'Ukryj',
    motorbikes: 'Motocykle',
    agricultural_machines: 'Maszyny rolnicze',
    campers: 'Kampery',
    vehicle_type: 'Typ pojazdu',
    motorbike_model: 'Model',
    motorbike_brand: 'Marka',
    brand_options: [
      {
        optionLabel: 'Access Motor',
        optionVal: 33
      },
      {
        optionLabel: 'Aprilia',
        optionVal: 3
      },
      {
        optionLabel: 'BMW',
        optionVal: 2
      },
      {
        optionLabel: 'Benelli',
        optionVal: 18
      },
      {
        optionLabel: 'Beta',
        optionVal: 23
      },
      {
        optionLabel: 'Bimota',
        optionVal: 20
      },
      {
        optionLabel: 'Buell',
        optionVal: 4
      },
      {
        optionLabel: 'CFMoto',
        optionVal: 28
      },
      {
        optionLabel: 'Can Am',
        optionVal: 31
      },
      {
        optionLabel: 'Daelim',
        optionVal: 24
      },
      {
        optionLabel: 'Ducati',
        optionVal: 5
      },
      {
        optionLabel: 'Harley-Davidson',
        optionVal: 6
      },
      {
        optionLabel: 'Honda',
        optionVal: 1
      },
      {
        optionLabel: 'Husaberg',
        optionVal: 26
      },
      {
        optionLabel: 'Husqvarna',
        optionVal: 7
      },
      {
        optionLabel: 'Hyosung',
        optionVal: 25
      },
      {
        optionLabel: 'Indian',
        optionVal: 8
      },
      {
        optionLabel: 'KTM',
        optionVal: 10
      },
      {
        optionLabel: 'Kawasaki',
        optionVal: 9
      },
      {
        optionLabel: 'Kymco',
        optionVal: 22
      },
      {
        optionLabel: 'MV Agusta',
        optionVal: 12
      },
      {
        optionLabel: 'Moto-Guzzi',
        optionVal: 11
      },
      {
        optionLabel: 'Peugeot',
        optionVal: 27
      },
      {
        optionLabel: 'Piaggio',
        optionVal: 19
      },
      {
        optionLabel: 'Polaris',
        optionVal: 30
      },
      {
        optionLabel: 'Royal Enfield',
        optionVal: 32
      },
      {
        optionLabel: 'Suzuki',
        optionVal: 13
      },
      {
        optionLabel: 'TGB',
        optionVal: 29
      },
      {
        optionLabel: 'Triumph',
        optionVal: 14
      },
      {
        optionLabel: 'Vespa',
        optionVal: 21
      },
      {
        optionLabel: 'Victory',
        optionVal: 15
      },
      {
        optionLabel: 'Yamaha',
        optionVal: 16
      }
    ]
  },
  my_vehicles: {
    title: 'Moje pojazdy',
    in_stock: 'Na stanie',
    sold: 'Sprzedane',
    add_vehicle: 'Dodaj pojazd',
    edit_vehicle: 'Edytuj pojazd',
    vehicle: 'Pojazd',
    actions: 'Akcje',
    details: 'Szczegóły pojazdu',
    mark_as_sold: 'Oznacz pojazd jako sprzedany',
    mark_as_in_stock: 'Przywróć pojazd na stan',
    toast_marked_sold: 'Oznaczono {{name}} jako sprzedany',
    toast_restored_stock: 'Przywrócono {{name}} na stan',
    toast_vehicle_fallback: 'pojazd',
    toast_vehicle_added: 'Dodano pojazd',
    toast_issue_invoice: 'Wystaw fakturę',
    documents: 'Dokumenty',
    no_documents: 'Brak dokumentów dla tego pojazdu',
    photos: 'Zdjęcia',
    photos_empty: 'Ten pojazd nie ma jeszcze zdjęć.',
    add_photo: 'Dodaj zdjęcie',
    delete_photo_title: 'Usunąć zdjęcie?',
    delete_photo_message: 'Zdjęcie zostanie usunięte z galerii tego pojazdu.',
    photo_added: 'Zdjęcie zostało dodane',
    photo_deleted: 'Zdjęcie zostało usunięte',
    photo_type_error: 'Dozwolone są tylko pliki JPEG i PNG.',
    photo_upload_error: 'Nie udało się zapisać zdjęcia',
    edit: 'Edytuj',
    delete: 'Usuń',
    view_offer: 'Zobacz ofertę',
    empty_title: 'Dodaj pierwszy pojazd',
    empty_subtitle: 'Do każdego motocykla wystawisz dokumenty dla swoich klientów.',
    sold_empty_title: 'Sprzedałeś pojazd? Oznacz go jako sprzedany.',
    sold_empty_subtitle: 'Przeniesiemy go tutaj z całą dokumentacją, dzięki czemu masz porządek w pojazdach na stanie.',
    vehicle_data: 'Dane pojazdu',
    source_purchased: 'Wybierz z skupowanych',
    source_own: 'Dodaj własny pojazd',
    brand: 'Marka',
    model: 'Model',
    year: 'Rocznik',
    mileage: 'Przebieg',
    vin: 'VIN',
    choose: 'Wybierz',
    mileage_placeholder: 'np.  2500',
    vin_placeholder: 'np. JYARM22E0LA001234',
    vin_tooltip: 'Numer identyfikacyjny pojazdu (17 znaków).',
    discard: 'Porzuć',
    add: 'Dodaj',
    save: 'Zapisz',
    km: 'km',
    ccm: 'cm³',
    kw: 'kW',
    field_integer: 'Podaj liczbę całkowitą',
    search_purchased: 'Szukaj motocykli...',
    choose_vehicle: 'Wybierz pojazd',
    loading_offers: 'Ładowanie...',
    no_purchased: 'Brak motocykli',
    field_required: 'Uzupełnij to pole',
    promotion: 'Promocje',
    promotion_empty_title: 'Brak promocji',
    promotion_empty_subtitle:
      'Gdy ogłoszenie będzie na mobile.de albo na innym portalu, na przykład Otomoto, pojawi się tutaj.',
    promotion_mobile: 'mobile.de',
    promotion_otomoto: 'Otomoto',
    promotion_listed: 'Ogłoszenie wystawione',
    promotion_paused: 'Wstrzymane',
    promotion_pause: 'Wstrzymaj',
    promotion_resume: 'Wznów',
    promotion_delete: 'Usuń',
    promotion_public_link: 'Zobacz ogłoszenie',
    add_promotion: 'Dodaj promocję',
    promotion_photos: 'Zdjęcia na ogłoszeniu',
    promotion_photos_pick: 'Wybierz zdjęcia',
    promotion_photos_none: 'Ogłoszenie powstanie bez zdjęć.',
    promotion_photos_empty: 'Ten pojazd nie ma zdjęć. Dodaj je na stronie pojazdu.',
    promotion_photos_hint: 'Zaznacz zdjęcia z galerii tego pojazdu.',
    promotion_photos_limit: 'Możesz wybrać najwyżej {{count}} zdjęć.',
    promotion_photos_confirm: 'Zapisz wybór',
    promotion_photo_cover: 'Główne',
    promotion_photo_make_cover: 'Ustaw główne',
    edit_promotion: 'Edytuj promocję',
    promotion_form_title: 'Promocja na mobile.de',
    promotion_price: 'Cena',
    promotion_price_placeholder: 'np. 12500',
    promotion_category: 'Kategoria',
    promotion_description: 'Opis',
    promotion_description_placeholder: 'Opis ogłoszenia',
    promotion_description_bold: 'Pogrubienie',
    promotion_description_list: 'Lista',
    promotion_description_rule: 'Linia',
    promotion_description_undo: 'Cofnij',
    promotion_description_redo: 'Ponów',
    promotion_highlight: 'Zaleta',
    promotion_highlight_placeholder: 'np. ABS',
    promotion_section_vehicle: 'Pojazd',
    promotion_section_equipment: 'Wyposażenie',
    promotion_section_service: 'Serwis',
    promotion_power: 'Moc',
    promotion_capacity: 'Pojemność',
    promotion_drive_type: 'Napęd',
    promotion_gear_box: 'Skrzynia biegów',
    promotion_color: 'Kolor',
    promotion_metallic: 'Lakier metalik',
    promotion_vat: 'VAT',
    promotion_damage: 'Uszkodzenia nienaprawione',
    promotion_abs: 'ABS',
    promotion_heated_grips: 'Podgrzewane manetki',
    promotion_box: 'Kufer',
    promotion_windshield: 'Szyba',
    promotion_kickstarter: 'Rozrusznik nożny',
    promotion_owners: 'Liczba poprzednich właścicieli',
    promotion_last_inspection: 'Ostatni przegląd',
    promotion_new_inspection: 'Nowy przegląd',
    promotion_service_history: 'Pełna historia serwisowa',
    promotion_yes: 'Tak',
    promotion_no: 'Nie',
    promotion_month_placeholder: 'RRRR-MM',
    promotion_months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień'
    ],
    promotion_vat_23: '23%',
    promotion_vat_19: '19%',
    promotion_vat_none: 'VAT niepodlegający odliczeniu',
    promotion_gear_manual: 'Manualna',
    promotion_gear_automatic: 'Automatyczna',
    promotion_drive_chain: 'Łańcuch',
    promotion_drive_belt: 'Pas',
    promotion_drive_shaft: 'Wał',
    promotion_colors: {
      BLACK: 'Czarny',
      GREY: 'Szary',
      BEIGE: 'Beżowy',
      BROWN: 'Brązowy',
      RED: 'Czerwony',
      GREEN: 'Zielony',
      BLUE: 'Niebieski',
      PURPLE: 'Fioletowy',
      GOLD: 'Złoty',
      WHITE: 'Biały',
      ORANGE: 'Pomarańczowy',
      SILVER: 'Srebrny',
      YELLOW: 'Żółty'
    },
    promotion_create_error: 'Nie udało się dodać promocji na mobile.de.',
    promotion_update_error: 'Nie udało się zapisać promocji na mobile.de.',
    toast_promotion_added: 'Promocja na mobile.de została dodana',
    toast_promotion_updated: 'Promocja na mobile.de została zaktualizowana',
    toast_promotion_paused: 'Ogłoszenie zostało wstrzymane na mobile.de',
    toast_promotion_deleted: 'Ogłoszenie zostało usunięte z mobile.de',
    toast_promotion_resumed: 'Ogłoszenie zostało ponownie wystawione na mobile.de',
    promotion_categories: {
      ChopperAndCruiser: 'Chopper / cruiser',
      CombinationAndSidecar: 'Motocykl z wózkiem',
      DirtBike: 'Cross',
      EnduroAndTouringEnduro: 'Enduro',
      LightweightMotorcycleAndMotorbike: 'Motocykl lekki',
      MotorAssistedBicycleAndSmallMoped: 'Motorower',
      Motorcycle: 'Motocykl',
      NakedBike: 'Naked',
      Pocketbike: 'Pocket bike',
      Racing: 'Wyścigowy',
      RallyAndCross: 'Rajd / cross',
      Scooter: 'Skuter',
      SportTouringMotorcycle: 'Sport touring',
      SportsAndSuperSportsBike: 'Sport',
      Streetfighter: 'Streetfighter',
      SuperMoto: 'Supermoto',
      Tourer: 'Turystyczny',
      Trike: 'Trike',
      OtherMotorbike: 'Inny',
      Quad: 'Quad'
    },
    add_document: 'Dodaj dokument',
    document_invoice: 'Faktura',
    document_sell_contract: 'Umowa sprzedaży',
    document_import: 'Dokument importowy',
    document_open: 'Otwórz',
    document_download: 'Pobierz',
    documents_empty_title: 'Dodaj pierwszy dokument',
    documents_empty_subtitle: 'Wystawisz tu fakturę, umowę i dokument importowy dla tego motocykla.'
  },
  clients: {
    title: 'Klienci',
    add_client: 'Dodaj klienta',
    name: 'Nazwa klienta',
    email: 'E-mail',
    phone: 'Numer telefonu',
    country: 'Kraj',
    actions: 'Akcje',
    details: 'Szczegóły klienta',
    edit: 'Edytuj',
    delete: 'Usuń',
    copy_email: 'Kopiuj e-mail',
    email_copied: 'Skopiowano',
    empty_title: 'Dodaj pierwszego klienta',
    empty_subtitle: 'Klienci pojawią się tutaj po dodaniu.',
    edit_client: 'Edytuj klienta',
    client_data: 'Dane klienta',
    company: 'Firma',
    personal: 'Osoba prywatna',
    company_name: 'Nazwa firmy',
    document_number: 'Numer dokumentu',
    vat_number: 'Numer VAT',
    id_number: 'Numer dowodu',
    place: 'Miejscowość',
    zip_code: 'Kod pocztowy',
    street: 'Ulica',
    house_number: 'Numer domu',
    first_name: 'Imię',
    last_name: 'Nazwisko',
    company_name_placeholder: 'np. AutoMoto Sp. z o.o.',
    document_number_placeholder: 'np. 5272847523',
    vat_number_placeholder: 'np. PL5272847523',
    id_number_placeholder: 'np. ABC123456',
    place_placeholder: 'np. Warszawa',
    zip_code_placeholder: 'np. 00-624',
    street_placeholder: 'np. Marszałkowska',
    house_number_placeholder: 'np. 12/4',
    first_name_placeholder: 'np. Tomasz',
    last_name_placeholder: 'np. Kowalski',
    email_placeholder: 'np. t.kowalski@automoto.pl',
    phone_placeholder: 'np. +48 512 345 678',
    tax_number: 'Numer podatkowy',
    full_name: 'Imię i nazwisko',
    city: 'Miasto',
    documents: 'Lista dokumentów',
    documents_empty_subtitle: 'Wystawisz tu fakturę, umowę i dokument importowy dla tego klienta.',
    search: 'Szukaj',
    document_invoice: 'Faktura',
    document_contract: 'Umowa',
    document_import: 'Dokument importu',
    countries: {
      poland: 'Polska',
      germany: 'Niemcy'
    }
  },
  sell_contract: {
    contract_data: 'Dane umowy',
    vehicle: 'Pojazd',
    client: 'Klient',
    contract_language: 'Język umowy',
    select: 'Wybierz',
    select_client: 'Wybierz klienta',
    select_vehicle: 'Wybierz pojazd',
    search_clients: 'Szukaj klientów...',
    no_clients: 'Brak klientów',
    currency: 'Waluta',
    vat_rate: 'Stawka VAT',
    price: 'Cena',
    gross: 'Brutto',
    net: 'Netto',
    net_price: 'Cena netto',
    vat: 'VAT ({{rate}}%)',
    gross_price: 'Cena brutto',
    additional_services: 'Usługi dodatkowe',
    additional_service_name: 'Nazwa',
    additional_service_amount: 'Kwota',
    additional_service_add: 'Dodaj usługę',
    additional_service_remove: 'Usuń',
    additional_service_total: 'Cena łączna',
    down_payment: 'Zaliczka',
    down_payment_amount: 'Kwota zaliczki',
    payment_method: 'Metoda płatności',
    payment_type: 'Typ płatności',
    bank_transfer: 'Przelew',
    instant_transfer: 'Przelew natychmiastowy',
    cash: 'Gotówka',
    financing: 'Finansowanie',
    date: 'Data',
    on_contract: 'Umowa',
    down_payment_date: 'Data zaliczki',
    delivery: 'Dostawa',
    date_format: 'Format daty',
    exact_date: 'Dokładna data',
    time_span: 'Przedział czasu',
    delivery_date: 'Data dostawy',
    delivery_period: 'Okres dostawy',
    commitment: 'Zobowiązanie',
    binding: 'Wiążące',
    non_binding: 'Niewiążące',
    delivery_method: 'Sposób dostawy',
    delivery_place: 'Miejsce albo adres dostawy',
    additional_service_delivery_cost: 'To jest koszt wydania',
    payment_due: 'Termin wymagalności',
    payment_due_handover: 'Przy wydaniu za fakturę',
    payment_due_custom: 'Inny termin',
    payment_due_text: 'Uzgodniony termin',
    registration_state: 'Stan rejestracji przy wydaniu',
    registration_deregistered: 'Wyrejestrowany',
    registration_registered: 'Zarejestrowany',
    registration_by: 'Rejestrację wykonuje',
    registration_seller: 'Sprzedawca',
    registration_buyer: 'Kupujący',
    client_delivery: 'Odbiór klienta',
    dealer_delivery: 'Dostawa dealera',
    damages: 'Uszkodzenia i odchylenia',
    remarks: 'Uwagi / inne',
    remarks_hint: 'Tu możesz wpisać znane wady, szkody, problemy i inne informacje o pojeździe.',
    previous_owner_damages: 'Uszkodzenia i odchylenia poprzedniego właściciela',
    yes: 'Tak',
    no: 'Nie',
    not_specified: 'Nie określono',
    exclude_updates: 'Czy wyłączyć obowiązek aktualizacji produktów cyfrowych i towarów z elementami cyfrowymi?',
    shorten_warranty: 'Skrócić gwarancję do jednego roku',
    language_de: 'Niemiecki',
    language_pl: 'Polski',
    vat_23: '23% VAT',
    vat_10: '10% VAT',
    vat_5: '5% VAT',
    vat_marginal: 'Opodatkowanie marży',
    vat_small_business: 'Mała firma',
    month_1: '1 miesiąc',
    month_2: '2 miesiące',
    month_3: '3 miesiące',
    month_4: '4 miesiące',
    month_5: '5 miesięcy',
    description: 'Opis',
    objective_deviations: 'Czy są odstępstwa od obiektywnych wymagań?',
    objective_deviation_1: 'Opis odstępstwa',
    objective_deviation_placeholder: 'Element, stan i skutki użytkowania',
    further_agreements: 'Dalsze uzgodnienia co do właściwości',
    further_agreements_placeholder: 'Jeśli nic nie ustalono, zostaw puste',
    eur: 'EUR (€)',
    pln: 'PLN (zł)',
    date_placeholder: 'DD.MM.RRRR',
    field_required: 'Uzupełnij to pole',
    vin_value: 'VIN: {{vin}}',
    mileage_value: 'Przebieg {{mileage}}',
    year_value: 'Rok: {{year}}',
    email_value: 'E-mail: {{email}}',
    phone_value: 'Telefon: {{phone}}',
    address_value: 'Adres: {{address}}',
    mileage_statement: 'Oświadczenie o przebiegu',
    mileage_statement_known: 'Znam przebieg',
    mileage_statement_unknown: 'Nie znam przebiegu',
    mileage_statement_custom: 'Własny zapis o przebiegu',
    mileage_statement_text: 'Treść uzgodnienia o przebiegu',
    previous_owners_basis: 'Podstawa informacji o poprzednich właścicielach',
    previous_owners_basis_placeholder: 'Dokumenty lub konkretne informacje',
    key_count: 'Liczba kluczy',
    other_equipment: 'Inne wyposażenie',
    missing_items: 'Brakujące dokumenty lub części'
  },
  unsaved_changes: {
    title: 'Masz niezapisane zmiany',
    body: 'Jeśli wyjdziesz teraz, wprowadzone dane przepadną.',
    leave: 'Wyjdź bez zapisu',
    stay: 'Wróć do edycji'
  },
  mobile_redirect: {
    title: 'Pobierz naszą aplikacje mobilną',
    subtitle: 'aby przegladać aktualne oferty w próbnej wersji.',
    step1: 'Pobierz Estigroup na Twój telefon (Android/iOS).',
    step2: 'Zaloguj się używając',
    step2_highlight: 'tego samego e-maila',
    step3: 'i hasła wysłanego na Twoją skrzynkę odbiorczą.',
    step4: 'Otrzymasz dostep do aktualnych ofert w wersji demo.',
    open_app: 'Otwórz aplikację mobilną',
    google_play: 'Google Play',
    app_store: 'App Store'
  },
  invoice_form: {
    sales_invoices: 'Faktury sprzedażowe',
    add_invoice: 'Dodaj fakturę',
    edit_invoice: 'Edytuj fakturę',
    invoice_data: 'Dane klienta',
    nip: 'NIP: {{number}}',
    invoice_number: 'Numer faktury',
    invoice_number_placeholder: 'np. FV/2026/001',
    invoice_language: 'Język faktury',
    language_en: 'Angielski',
    invoice_date: 'Data faktury',
    payment_due: 'Termin płatności',
    additional_info: 'Dodatkowe informacje'
  }
}
